"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@headlessui/react");
var _reactFeather = require("react-feather");
var _ModalFooter = require("./ModalFooter");
var _ModalBody = require("./ModalBody");
var _ModalHeader = require("./ModalHeader");
var _classnames = _interopRequireDefault(require("classnames"));
var _Theme = require("../Theme");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ModalComponent = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    open,
    onClose,
    closeIcon = true,
    size = "sm",
    unmount,
    initialFocus,
    children,
    className,
    ...props
  } = _ref;
  const {
    theme: {
      modal: {
        component: componentTheme
      }
    }
  } = (0, _Theme.useThemeConfig)();
  return /*#__PURE__*/_react.default.createElement(_react2.Transition.Root, {
    show: open,
    as: _react.Fragment
  }, /*#__PURE__*/_react.default.createElement(_react2.Dialog, {
    as: "div",
    onClose: onClose,
    className: componentTheme.root,
    unmount: unmount,
    initialFocus: initialFocus
  }, /*#__PURE__*/_react.default.createElement(_react2.Transition.Child, {
    as: _react.Fragment,
    enter: componentTheme.backdropAnimation.enter,
    enterFrom: componentTheme.backdropAnimation.enterFrom,
    enterTo: componentTheme.backdropAnimation.enterTo,
    leave: componentTheme.backdropAnimation.leave,
    leaveFrom: componentTheme.backdropAnimation.leaveFrom,
    leaveTo: componentTheme.backdropAnimation.leaveTo
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: componentTheme.backdrop
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: componentTheme.center
  }, /*#__PURE__*/_react.default.createElement(_react2.Transition.Child, {
    as: _react.Fragment,
    enter: componentTheme.panelAnimation.enter,
    enterFrom: componentTheme.panelAnimation.enterFrom,
    enterTo: componentTheme.panelAnimation.enterTo,
    leave: componentTheme.panelAnimation.leave,
    leaveFrom: componentTheme.panelAnimation.leaveFrom,
    leaveTo: componentTheme.panelAnimation.leaveTo
  }, /*#__PURE__*/_react.default.createElement(_react2.Dialog.Panel, _extends({
    className: (0, _classnames.default)(componentTheme.base, componentTheme.size[size], className),
    as: "div",
    ref: ref
  }, props), closeIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: componentTheme.closeBtn.position
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: componentTheme.closeBtn.base,
    "aria-label": "Close",
    onClick: () => onClose(false)
  }, /*#__PURE__*/_react.default.createElement(_reactFeather.X, {
    className: componentTheme.closeBtn.size,
    "aria-hidden": "true"
  }))), children)))));
});
ModalComponent.displayName = "Modal";
const Modal = Object.assign(ModalComponent, {
  Header: _ModalHeader.ModalHeader,
  Body: _ModalBody.ModalBody,
  Footer: _ModalFooter.ModalFooter
});
exports.Modal = Modal;